import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { Emdash } from "~/components/Punctuation";
import { DataGridDollarPercentChangeComboCell } from "~/components/DataGrid/DataGridDollarPercentChangeComboCell";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { AssetTableRowData } from "../types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

// // // //

export const BRIDGED_TOKEN_VALUE_DOLLAR_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.bridgedTokenValueDollar,
    label: "Total Value",
    tooltip: CatalogMetricSlugs.bridged_token_value_dollar,
    type: ColumnTypes.dollar,
    sortsOn: AssetColumns.bridgedTokenValueDollar,
    width: 175,
    render: (item) => {
        const measure = getMeasureValue(item, "bridged_token_value_dollar");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridDollarPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_7d_pct}
            />
        );
    },
};
